package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.SettingsBackupRestoreW500Rounded: ImageVector
    get() {
        if (_settingsBackupRestoreW500Rounded != null) {
            return _settingsBackupRestoreW500Rounded!!
        }
        _settingsBackupRestoreW500Rounded = Builder(name = "SettingsBackupRestoreW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(479.76f, 848.13f)
                quadToRelative(-127.79f, 0.0f, -226.17f, -76.86f)
                quadToRelative(-98.37f, -76.86f, -129.29f, -196.81f)
                quadToRelative(-4.71f, -16.92f, 6.6f, -31.09f)
                quadToRelative(11.32f, -14.17f, 30.53f, -16.65f)
                quadToRelative(18.09f, -2.48f, 33.12f, 6.6f)
                quadToRelative(15.04f, 9.07f, 20.75f, 26.75f)
                quadToRelative(25.2f, 87.13f, 98.44f, 142.09f)
                quadToRelative(73.25f, 54.97f, 166.02f, 54.97f)
                quadToRelative(115.8f, 0.0f, 196.47f, -80.67f)
                quadTo(756.89f, 595.8f, 756.89f, 480.0f)
                quadToRelative(0.0f, -115.8f, -80.66f, -196.47f)
                quadToRelative(-80.67f, -80.66f, -196.47f, -80.66f)
                quadToRelative(-66.13f, 0.0f, -124.22f, 29.97f)
                quadToRelative(-58.08f, 29.96f, -98.37f, 83.09f)
                horizontalLineToRelative(61.4f)
                quadToRelative(17.81f, 0.0f, 29.86f, 12.1f)
                reflectiveQuadToRelative(12.05f, 29.82f)
                quadToRelative(0.0f, 17.72f, -12.05f, 29.93f)
                quadTo(336.38f, 400.0f, 318.57f, 400.0f)
                lineTo(159.52f, 400.0f)
                quadToRelative(-19.15f, 0.0f, -32.32f, -13.17f)
                quadToRelative(-13.18f, -13.18f, -13.18f, -32.33f)
                verticalLineToRelative(-158.8f)
                quadToRelative(0.0f, -17.72f, 12.1f, -29.7f)
                reflectiveQuadToRelative(29.81f, -11.98f)
                quadToRelative(17.71f, 0.0f, 29.7f, 11.98f)
                quadToRelative(11.98f, 11.98f, 11.98f, 29.7f)
                verticalLineToRelative(48.73f)
                quadToRelative(52.19f, -63.52f, 126.0f, -98.04f)
                reflectiveQuadToRelative(156.15f, -34.52f)
                quadToRelative(76.66f, 0.0f, 143.6f, 29.1f)
                reflectiveQuadTo(740.0f, 219.76f)
                quadToRelative(49.7f, 49.7f, 78.79f, 116.65f)
                quadToRelative(29.1f, 66.94f, 29.1f, 143.6f)
                reflectiveQuadToRelative(-29.1f, 143.6f)
                quadTo(789.7f, 690.54f, 740.0f, 740.24f)
                quadToRelative(-49.7f, 49.69f, -116.64f, 78.79f)
                quadToRelative(-66.94f, 29.1f, -143.6f, 29.1f)
                close()
                moveTo(479.86f, 563.59f)
                quadToRelative(-34.53f, 0.0f, -59.11f, -24.55f)
                quadToRelative(-24.58f, -24.54f, -24.58f, -59.01f)
                quadToRelative(0.0f, -34.46f, 24.56f, -59.04f)
                quadToRelative(24.55f, -24.58f, 59.03f, -24.58f)
                quadToRelative(34.58f, 0.0f, 59.2f, 24.46f)
                quadToRelative(24.63f, 24.46f, 24.63f, 59.13f)
                reflectiveQuadToRelative(-24.6f, 59.13f)
                quadToRelative(-24.59f, 24.46f, -59.13f, 24.46f)
                close()
            }
        }
        .build()
        return _settingsBackupRestoreW500Rounded!!
    }

private var _settingsBackupRestoreW500Rounded: ImageVector? = null
